import { useEffect } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import NextImage from '@/components/NextImage';

export default function Smart() {
    const { t } = useLang('bladeroboticlawnmower');

    useEffect(() => {
        AniContainer.create({
            asyncFromTo: [
                ['.industry-desc', { scale: 1.2, opacity: 0 }, { scale: 0.7, opacity: 1 }, 1],
                ['.industry-desc', { scale: 0.7, opacity: 1 }, { scale: 0.7, opacity: 0 }, 1],
            ],
            asyncTimeLine: [0, 2],
            triggerElement: '.mod-industry',
            triggerHook: 1,
            offset: 150,
            duration: '46%',
        });
        AniContainer.create({
            asyncFromTo: [
                ['.mod-industry-box', { scale: 1.2, opacity: 0 }, { scale: 1, opacity: 1 }, 1],
                ['.ani-aiming', { opacity: 0 }, { opacity: 1 }, 1],
                ['.mod-industry-box', { scale: 1, opacity: 1 }, { opacity: 0, scale: 0.5 }, 2.5],
            ],
            asyncTimeLine: [0, 0.5, 2],
            triggerElement: '.mod-industry-box',
            triggerHook: 0.4,
            offset: 0,
            duration: '90%',
        });
    }, []);

    return (
        <div className={css['blade-smart']}>
            <div className="sticky-box">
                <div className="mod-industry">
                    <p className="industry-desc">{t('detail.sec2_title')}</p>
                </div>
                <div className="box-center">
                    <ul className="mod-industry-box">
                        <li className="column-1">
                            <div className="img-box">
                                <NextImage
                                    webpSrc={require('@publicLocal/blade/detail/pc/02-1@2x.webp')}
                                    src={require('@publicLocal/blade/detail/pc/02-1@2x.jpg')}
                                    alt={t('detail.sec2_bg1_desc')}
                                    aria-label={t('detail.sec2_bg1_desc')}
                                />
                                <p className="desc">{t('detail.sec2_bg1_desc')}</p>
                            </div>
                            <div className="img-box img-box2">
                                <NextImage
                                    webpSrc={require('@publicLocal/blade/detail/pc/02-2@2x.webp')}
                                    src={require('@publicLocal/blade/detail/pc/02-2@2x.jpg')}
                                    alt={t('detail.sec2_bg2_desc')}
                                    aria-label={t('detail.sec2_bg2_desc')}
                                />
                                <p className="desc">
                                    {t.rich('detail.sec2_bg2_desc', {
                                        blue: (text: string) => <span className="title linear-text-blue">{text}</span>,
                                    })}
                                </p>
                            </div>
                        </li>
                        <li className="column-2">
                            <div className="img-box">
                                <NextImage
                                    webpSrc={require('@publicLocal/blade/detail/pc/02-3@2x.webp')}
                                    src={require('@publicLocal/blade/detail/pc/02-3@2x.jpg')}
                                    alt={t('detail.sec2_bg3_desc')}
                                    aria-label={t('detail.sec2_bg3_desc')}
                                />
                            </div>
                            <div className="text-box">
                                <p className="desc">
                                    {t.rich('detail.sec2_bg3_desc', {
                                        blue: (text: string) => <span className="linear-text-blue">{text}</span>,
                                    })}
                                </p>
                            </div>
                        </li>
                        <li className="column-3">
                            <div className="img-box1">
                                <NextImage
                                    webpSrc={require('@publicLocal/blade/detail/pc/02-4@2x.webp')}
                                    src={require('@publicLocal/blade/detail/pc/02-4@2x.jpg')}
                                    alt={t('detail.sec2_bg4_desc')}
                                    aria-label={t('detail.sec2_bg4_desc')}
                                />
                                <p className="desc">
                                    {t.rich('detail.sec2_bg4_desc', {
                                        blue: (text: string) => <span className="title linear-text-blue">{text}</span>,
                                    })}
                                </p>
                            </div>
                            <div className="img-box2">
                                <div>
                                    <NextImage
                                        webpSrc={require('@publicLocal/blade/detail/pc/02-5@2x.webp')}
                                        src={require('@publicLocal/blade/detail/pc/02-5@2x.jpg')}
                                        alt={t('detail.sec2_bg5_desc')}
                                        aria-label={t('detail.sec2_bg5_desc')}
                                    />
                                    <p className="desc linear-text-green">{t('detail.sec2_bg5_desc')}</p>
                                </div>
                                <div>
                                    <NextImage
                                        webpSrc={require('@publicLocal/blade/detail/pc/02-6@2x.webp')}
                                        src={require('@publicLocal/blade/detail/pc/02-6@2x.jpg')}
                                        alt={t('detail.sec2_bg6_desc')}
                                        aria-label={t('detail.sec2_bg6_desc')}
                                    />
                                    <p className="desc linear-text-blue">{t('detail.sec2_bg6_desc')}</p>
                                </div>
                            </div>
                            <div className="img-box3">
                                <NextImage
                                    webpSrc={require('@publicLocal/blade/detail/pc/02-7@2x.webp')}
                                    src={require('@publicLocal/blade/detail/pc/02-7@2x.jpg')}
                                    alt={t('detail.sec2_bg7_desc')}
                                    aria-label={t('detail.sec2_bg7_desc')}
                                />
                                <p className="desc">{t('detail.sec2_bg7_desc')}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
